import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useState, useEffect, useRef } from 'react';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { getRequest, postRequest } from '../../globalhelper/helper';
import './transactions.css';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Grid, Paper, Tab, Table, TableBody, TableCell, TableRow, Tabs, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { TableContainer, TableHead } from '@material-ui/core';
function CustomTabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;
  return <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{
      p: 3
    }}>{children}</Box>}
    </div>;
}
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

// Helper function to render object values as strings
const renderValue = value => {
  if (value === null || value === undefined) {
    return 'N/A';
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch (error) {
      return 'Invalid data';
    }
  }
  return value.toString();
};
const Transactions = () => {
  const [tab, setTab] = useState(0);
  const [transactionData1, setTransactionData1] = useState([]);
  const [transactionData2, setTransactionData2] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [company, setCompany] = useState(null);
  const isMounted = useRef(true);
  useEffect(() => {
    // Set the mounted flag to true
    isMounted.current = true;

    // Fetch companies data
    const fetchCompanies = async () => {
      try {
        const result = await getRequest(`api/edureka/getCompanyAssignedToUser`);
        if (isMounted.current && result.res?.data) {
          const sortedCompanies = (result.res.data || []).sort((a, b) => (a.orgname || '').localeCompare(b.orgname || ''));
          setCompanies(sortedCompanies);
          if (sortedCompanies.length === 1) {
            setCompany(sortedCompanies[0]);
          }
        }
      } catch (error) {
        if (isMounted.current) {
          console.log('Error fetching companies:', error);
        }
      }
    };

    // Fetch transactions data
    const fetchTransactions = async () => {
      try {
        const result1 = await postRequest('api/transactions/getTransactions', {
          system: localStorage.getItem('system')
        });
        if (isMounted.current && result1.type === 'success') {
          const parsedData = JSON.parse(result1.res.data);
          // Ensure we have an array of transactions
          setTransactionData1(Array.isArray(parsedData) ? parsedData : [parsedData]);
        }
        const result2 = await postRequest('api/transactions/getPDMStatus', {
          system: localStorage.getItem('system')
        });
        if (isMounted.current && result2.type === 'success') {
          const parsedData = JSON.parse(result2.res.data);
          // Ensure we have an array of transactions
          setTransactionData2(Array.isArray(parsedData) ? parsedData : [parsedData]);
        }
      } catch (error) {
        if (isMounted.current) {
          console.error('Error fetching transactions:', error);
        }
      }
    };
    fetchCompanies();
    fetchTransactions();

    // Cleanup function to set isMounted to false when component unmounts
    return () => {
      isMounted.current = false;
    };
  }, []);
  const handleTnx = (event, newValue) => {
    setTab(newValue);
  };

  // Get all unique keys from the transaction data for table headers
  const getAllKeys = data => {
    const keys = new Set();
    data.forEach(item => {
      Object.keys(item).forEach(key => keys.add(key));
    });
    return Array.from(keys);
  };
  return <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1-content' id='panel1-header'>
          <Typography variant='h6'>Search Reports</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete size='small' fullWidth value={company} options={companies} getOptionLabel={option => option?.orgname || ''} isOptionEqualToValue={(option, value) => option?.orgid === value?.orgid} onChange={(event, newValue) => setCompany(newValue)} renderInput={params => <TextField {...params} label='Company' variant='outlined' name='Company' />} />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {company && company.orgid && <>
          <Box sx={{
        borderBottom: 1,
        borderColor: 'divider',
        mt: 2
      }}>
            <Tabs value={tab} onChange={handleTnx} aria-label='basic tabs example'>
              <Tab label='Transactions' {...a11yProps(0)} />
              <Tab label='PDM status' {...a11yProps(1)} />
            </Tabs>
          </Box>

          <CustomTabPanel value={tab} index={0}>
            {transactionData1.length > 0 ? <TableContainer component={Paper}>
                <Table>
              <TableHead>
                <TableRow>
                  {(transactionData1 && transactionData1.length > 0 ? Object.keys(transactionData1[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                  textAlign: 'left'
                }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {(transactionData1 || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
                  let displayVal = val;
                  if (typeof val === 'number' && !Number.isInteger(val)) {
                    displayVal = val.toFixed(2);
                  } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                    displayVal = parseFloat(val).toFixed(2);
                  } else if (typeof val === 'boolean') {
                    displayVal = val ? 'Yes' : 'No';
                  } else if (val === null || val === undefined) {
                    displayVal = '';
                  } else if (typeof val === 'object') {
                    displayVal = JSON.stringify(val);
                  }
                  return <TableCell key={valIndex} sx={{
                    textAlign: 'left'
                  }}>
                          {String(displayVal)}
                        </TableCell>;
                })}
                  </TableRow>)}
              </TableBody>
            </Table>
              </TableContainer> : <Typography variant="body1" sx={{
          p: 2
        }}>
                No transaction data available.
              </Typography>}
          </CustomTabPanel>

          <CustomTabPanel value={tab} index={1}>
            {transactionData2.length > 0 ? <TableContainer component={Paper}>
                <Table>
              <TableHead>
                <TableRow>
                  {(transactionData2 && transactionData2.length > 0 ? Object.keys(transactionData2[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                  textAlign: 'left'
                }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {(transactionData2 || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
                  let displayVal = val;
                  if (typeof val === 'number' && !Number.isInteger(val)) {
                    displayVal = val.toFixed(2);
                  } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                    displayVal = parseFloat(val).toFixed(2);
                  } else if (typeof val === 'boolean') {
                    displayVal = val ? 'Yes' : 'No';
                  } else if (val === null || val === undefined) {
                    displayVal = '';
                  } else if (typeof val === 'object') {
                    displayVal = JSON.stringify(val);
                  }
                  return <TableCell key={valIndex} sx={{
                    textAlign: 'left'
                  }}>
                          {String(displayVal)}
                        </TableCell>;
                })}
                  </TableRow>)}
              </TableBody>
            </Table>
              </TableContainer> : <Typography variant="body1" sx={{
          p: 2
        }}>
                No PDM status data available.
              </Typography>}
          </CustomTabPanel>
        </>}
    </>;
};
export default Transactions;